/* @flow */

export const RECURSO_ATENDIMENTO = 'atendimento';
export const RECURSO_BALCAO = 'balcao';
